import PastRecalls from 'src/components/ConnectedVehicle/PastRecalls/PastRecalls';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(PastRecalls);